import {turnLights} from "./TurnOnOffLights";

export default (args) => turnLights(args, true);